import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';


import { patchProject } from '../modules/project';

import { requestCalculationRemove, requestCalculationRename, requestCreateCalculation } from '../modules/calculation';

import { getUIText } from '../utils/index';

class TabBar extends Component {
  onCalculationRemove = (index, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if(this.props.onCalculationRemove) {
      this.props.onCalculationRemove(index);
    }
  }

  onCalculatioRename = (index, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    if(this.props.onCalculatioRename) {
      this.props.onCalculatioRename(index);
    }
  }

  render() {
    const { project, onCalculationIndexChange, onCalculationRemove, onCalculatioRename, onCreateCalculation, app, translations } = this.props;
    const { calculationIndex, calculations } = project;

    return (
      <div className="tab-bar">
        {calculations.map((item, index) => {
          return (
            <div key={index} className={'tab-item' + (calculationIndex === index ? ' active' : '')} onClick={onCalculationIndexChange.bind(this, index)} >
              <a className="tab-item-btn btn-edit-tab" onClick={this.onCalculatioRename.bind(this, index)}>
                <i className="fa fa-pencil"/>
              </a>
              {item.name}
              <a className="tab-item-btn btn-close-tab" onClick={this.onCalculationRemove.bind(this, index)}>
                <i className="fa fa-close"/>
              </a>
            </div>
          );
        }, this)}
        <a className={'tab-item tab-item-add' + (calculationIndex === -1 ? ' active' : '')} onClick={onCreateCalculation}>
          <i className="fa fa-plus mr-2"/>{getUIText('GENERAL-NEW', app.language, translations)}
        </a>
      </div>
    );
  }
}

TabBar.propTypes = {
    project: PropTypes.object,
    translations: PropTypes.object,
    app: PropTypes.object,
  onCalculationRemove: PropTypes.any,
  onCalculatioRename: PropTypes.any,
  onCalculationIndexChange: PropTypes.any,
  onCreateCalculation: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      project: state.project,
      translations: state.translations,
      app: state.app,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      onCalculationIndexChange: index => dispatch(patchProject({ calculationIndex: index })),
      onCalculatioRename: index => dispatch(requestCalculationRename({ index: index })),
      onCalculationRemove: index => dispatch(requestCalculationRemove({ index: index })),
      onCreateCalculation: e => dispatch(requestCreateCalculation()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TabBar);
